/* TODO: update according to reality */

import translate from "src/functions/translate";

function optionsDifficulty(lang: string) {
  return [
    { title: translate(`any`, lang), value: `any` },
    { title: translate(`beginner`, lang), value: `beginner` },
    { title: translate(`intermediate`, lang), value: `intermediate` },
    { title: translate(`advanced`, lang), value: `advanced` },
    { title: translate(`supreme`, lang), value: `superior` },
  ];
}

export default optionsDifficulty;
